import User, { UserDriverEditRequestBody } from "./user-driver-edit.request";

const createBody = (request: User): UserDriverEditRequestBody => {
  return {
    addresses: request.addresses,
    associations: request.associations,
    driver: request.driver,
    user: request.user,
  };
};

const userDriverEditRequestFactory = {
  createBody,
};

export default userDriverEditRequestFactory;
